import { useAuth } from "@/context/AuthContext";

export function useCan(permission) {
    const { user } = useAuth();
    if (!user) return false;
    if (user.role === "super_admin") return true;
    const perms = user.permissions || [];
    if (Array.isArray(permission)) {
        return permission.some((p) => perms.includes(p));
    }
    return perms.includes(permission);
}

export function useCanAll(...permissions) {
    const { user } = useAuth();
    if (!user) return false;
    if (user.role === "super_admin") return true;
    const perms = user.permissions || [];
    return permissions.every((p) => perms.includes(p));
}

export default function Can({ permission, children, fallback = null }) {
    const allowed = useCan(permission);
    return allowed ? <>{children}</> : fallback;
}
